<template>
    <div class="express-detail-page">
        <van-sticky>
            <van-nav-bar
                :style="{'paddingTop':statusBarHeight,'backgroundColor':'#FFFFFF'}"
                title="物流详情"
                left-arrow
                @click-left="$router.go(-1)"
            />
        </van-sticky>
        <div class="express-detail">
            <div class="express-info">
                <div class="status">
                    <i class="icon icon-express"></i>
                    已发货
                </div>
                <div class="express-name">
                    <span class="name">{{expressDetail.companyName}}</span>
                    <span class="num">{{expressDetail.deliveryTradeNo}}</span>
                    <span class="copy" @click="handleCopy(expressDetail.deliveryTradeNo)">复制</span>
                </div>
            </div>
            <div class="goods-box">
                <goodsCard :noPrice="true" :card-data="{
                    sku:  (expressDetail.skuProperties || []).join(','),
                    name: expressDetail.goodsName,
                    picUrl: expressDetail.goodsImage,
                    num: expressDetail.goodsNum,
                    goodsKinds: expressDetail.goodsKinds
                }" />
            </div>
            <div class="goods-num-box">
                共{{expressDetail.goodsNum}}件商品
            </div>
        </div>
    </div>
</template>
<script>
import {Toast} from 'vant';
import goodsCard from '../components/card.vue'
export default {
    components: {
        goodsCard,
    },
    data() {
        return {
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            statusBarHeight: 0,
            orderNo: this.$route.params.orderNo,
            expressDetail: {}
        }
    },
    created() {
        this.setCompatible();
        this.getDdeliveryDetail();
    },
    methods: {
        setCompatible() {
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
            }
        },
        getDdeliveryDetail() {
            this.$api.entityOrder.getDdeliveryDetail({
                orderNo: this.orderNo
            }).then((res)=>{
                if(res.success) {
                    this.expressDetail = res.data;
                }
            })
        },
        handleCopy(data) {
            let oInput = document.createElement("input");
            oInput.value = data;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象;
            document.execCommand("Copy"); // 执行浏览器复制命令
            Toast("复制成功");
            oInput.remove();
        },
    },
};
</script>
<style lang="less">
    html,body {
        background-color: #F8FAFC;
    }
</style>
<style lang="less" scoped>
.express-detail {
    padding: 32px;
    background-color: #fff;
    .express-info {
        display: flex;
        justify-content: space-between;
        font-size: 30px;
    }
    .status {
        color: #1f94ff;
        font-weight: 500;
        display: flex;
        align-items: center;
        font-family: PingFangSC-Medium, PingFang SC;
        .icon-express {
            margin-right: 5px;
            width: 26px;
            height: 32px;
            display: inline-block;
            background: url(../asset/images/icon_express.png) no-repeat center center /
                100% 100%;
        }
    }
    .express-name {
        font-size: 28px;
        .name {
            color: #999;
        }
        .num {
            color: #333;
            margin: 0 16px;
            padding-right: 16px;
            position: relative;
            font-size: 28px;
        &:after {
            content: "";
            position: absolute;
            width: 4px;
            height: 22px;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            background-color: #d8d8d8;
        }
        }
        .copy {
            color: #1f94ff;
        }
    }
    .goods-box {
        padding-top: 32px;
    }
    .goods-num-box {
        border-top: 1px solid #eaeaea;
        height: 104px;
        line-height: 104px;
        box-sizing: border-box;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        font-size: 28px;
    }
}
</style>